export const config = {

  localApiUrl: 'http://192.168.5.40:3001/api/v1/',
  localSocketUrl: 'http://192.168.5.40:3001',
 
  devApiUrl: 'https://api.ema.dev-bbrauncloud.com/api/v1/',
  devSocketUrl: 'https://api.ema.dev-bbrauncloud.com',
 
  uatApiUrl: 'https://api.ema.qas-bbrauncloud.com/api/v1/',
  uatSocketUrl: 'https://api.ema.qas-bbrauncloud.com',
 
  prodApiUrl: 'https://api.events-apac.bbraun.app/api/v1/',
  prodSocketUrl: 'https://api.events-apac.bbraun.app',

  iosStoreLink: 'https://apps.apple.com/us/app/b-braun-events/id1659825471',
  playStoreLink: 'https://play.google.com/store/apps/details?id=com.evtapp.bbraun',
 
  authRoles: {
    sa: ['SA'], // Only Super Admin has access
    admin: ['SA', 'Admin'], // Only SA & Admin has access
    editor: ['SA', 'Admin', 'Editor'], // Only SA & Admin & Editor has access
    user: ['SA', 'Admin', 'Editor', 'User'], // Only SA & Admin & Editor & User has access
    guest: ['SA', 'Admin', 'Editor', 'User', 'Guest'] // Everyone has accesss
  }
}
